import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _openBlock(), _createElementBlock("div", null, [_cache[0] || (_cache[0] = _createTextVNode(" 表单构建 ", -1)), _createVNode(_component_svg_icon, {
    "icon-class": "build"
  })]);
}